import React from 'react';

const BlogCard = ({ image, title, description, date, isHighlighted, link }) => {
  return (
    <div 
      className={`border-2 rounded-md overflow-hidden  ${
        isHighlighted ? 'border-[#AD2F3B]' : 'border-gray-300'
      } w-[370px] h-[450px] max-[440px]:h-[450px] max-[440px]:w-[350px]  p-[18px] box-border flex flex-col justify-between`}
    >
      <div>
        {/* Image */}
        <img 
        
          src={image} 
          alt={title} 
          className="w-full h-[170px] object-cover "
        />

        {/* Title */}
        <h3 
          className={`mt-[18px] text-[18px] font-semibold leading-[1.3] ${
            isHighlighted ? 'text-[#AD2F3B]' : 'text-black'
          } line-clamp-2`}
        >
          {title}
        </h3>

        {/* Description */}
        <p className="mt-[18px] text-[16px] text-gray-600 leading-[1.5] line-clamp-3">
          {description}
        </p>

        <p className="mt-2">
  <a
    href={link}
    target="_blank"
    rel="noopener noreferrer"
    className="text-gray-800 font-semibold no-underline"
  >
    👉 Read more
  </a>
</p>

      </div>

      {/* Line and Date */}
      <div className="mt-[15px]">
        <div className="border-t border-gray-300 mb-2"></div>
        <p className="text-[16px] text-gray-500 text-left">{date}</p>
      </div>
    </div>
  );
};

export default BlogCard;
